export const industryOptions = [
    "AI Services",
    "Software",
    "SaaS",
    "Real Estate",
    "Construction",
    "Healthcare",
    "Legal",
    "Home Services",
    "Education",
    "Consulting",
    "E-commerce"
];

export const toneOptions = [
    "Professional",
    "Modern",
    "Creative",
    "Luxury",
    "Friendly",
    "Bold"
];

export const goalOptions = [
    "Generate Leads",
    "Book Appointments",
    "Drive Sales",
    "Build Trust",
    "Showcase Portfolio"
];

export const ctaOptions = [
    "Get Started",
    "Book a Call",
    "Book a Demo",
    "Contact Us",
    "Request a Quote",
    "Book an Appointment"
];

export const brandStyleOptions = [
    "Premium",
    "Minimal",
    "Corporate",
    "Luxury",
    "Bold",
    "Modern"
];

export const pricePositioningOptions = [
    "Affordable",
    "Mid-Market",
    "Premium",
    "Luxury"
];

export const getRecommendedPages = (industry, subIndustry) => {
    const text = `${industry} ${subIndustry}`.toLowerCase();

    if (text.includes("sports") || text.includes("academy") || text.includes("training")) {
        return ["Home", "Programs", "About", "Contact"];
    }

    if (text.includes("ecommerce") || text.includes("store") || text.includes("shop")) {
        return ["Home", "Shop", "Collections", "Contact"];
    }

    if (text.includes("education") || text.includes("course") || text.includes("school")) {
        return ["Home", "Programs", "Admissions", "Contact"];
    }

    return ["Home", "About", "Services", "Contact"];
};